export enum sessionActionTypes {
  UPDATE_DHL_API_TOKEN = 'update_dhl_api_token',
  UPDATE_DHL_AGENT_TOKEN = 'update_dhl_agent_token',
  UPDATE_DHL_API_TOKEN_EXPIRATION_TIME = 'update_dhl_api_token_expiration_time',
  UPDATE_DHL_API_TOKEN_EXPIRED = 'update_dhl_api_token_expired',
  RESET_DHL_API_TOKEN = 'reset_dhl_api_token',
  UPDATE_AUTHENTICATING = 'update_authenticating',
  UPDATE_NEEDS_LOGIN = 'update_needs_login',
  UPDATE_NEEDS_SESSION_OPEN = 'update_needs_session_open',
  UPDATE_AUTH_ERROR_MESSAGE = 'update_auth_error_message',
  SESSION_EXIT_SHOW_MODAL = 'session_exit_show_modal',
  SESSION_RESET = 'session_reset',
  USER_INACTIVITY_SHOW_MODAL = 'user_inactivity_show_modal',
  UPDATE_USER_INACTIVITY_SECONDS = 'update_user_inactivity_seconds',
}
